"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XmlCharsDecoder = void 0;
var string_1 = require("@devexpress/utils/lib/utils/string");
var XmlCharsDecoder = (function () {
    function XmlCharsDecoder() {
    }
    XmlCharsDecoder.decode = function (val) {
        return string_1.StringUtils.isNullOrEmpty(val) ?
            val :
            val.replace(XmlCharsDecoder.xmlCharDecodingRegex, function (allStr, value) {
                var valueAsInt = parseInt(value, 10);
                return (!isNaN(valueAsInt) && (valueAsInt <= 0x1f || valueAsInt >= 0xffff)) ?
                    String.fromCharCode(valueAsInt) :
                    allStr;
            });
    };
    XmlCharsDecoder.xmlCharDecodingRegex = new RegExp('_x([\\da-fA-F]{4})_');
    return XmlCharsDecoder;
}());
exports.XmlCharsDecoder = XmlCharsDecoder;
